// extracted by mini-css-extract-plugin
export default {"viewAllButton":"invoicesCard_viewAllButton__Ju-SC"};